import { Badge, Icon } from "orcs-design-system";
import React from "react";
import styled from "styled-components";

import PropTypes from "prop-types";
import icons from "src/config/icons";
import GroupPropType from "src/custom-prop-types/group";
import { GroupTypesPropType } from "src/custom-prop-types/groupTypes";
import { getGroupBadgeVariant } from "src/util/group";

import GroupHierarchyBreadcrumb from "../GroupHierarchyBreadcrumb";

const StyledBadge = styled(Badge)`
  cursor: default;
`;

const CustomIcon = styled(Icon)`
  line-height: 1;
  padding-right: 4px;

  svg {
    opacity: 0.5;
    transition: opacity 300ms ease-in-out;
    transition-delay: 250ms;
  }
  &:hover {
    svg {
      opacity: 1;
    }
  }
`;

const GroupBadge = ({ group, groupTypes, showBreadcrumbIcon = true }) => {
  const badgeContent = (
    <StyledBadge
      display="block"
      variant={getGroupBadgeVariant(group, groupTypes)}
      data-testid={`group-badge-${group.id}`}
    >
      {showBreadcrumbIcon && (
        <CustomIcon icon={icons.groupBreadcrumb} size="s" />
      )}
      {group.name}
    </StyledBadge>
  );

  return (
    <GroupHierarchyBreadcrumb group={group} useChildren>
      <div>{badgeContent}</div>
    </GroupHierarchyBreadcrumb>
  );
};

GroupBadge.propTypes = {
  group: GroupPropType.isRequired,
  groupTypes: GroupTypesPropType.isRequired,
  showBreadcrumbIcon: PropTypes.bool,
};

export default GroupBadge;
